import axios from 'axios';
import config from './config';

const BASE_URL = config.baseApi;

const customAxios = axios.create({
  baseURL: BASE_URL,
});

const getAuthToken = () => {
  // 1. Check Query Parameter (?token=XYZ)
  const urlParams = new URLSearchParams(window.location.search);
  const queryToken = urlParams.get('token');
  if (queryToken) {
    sessionStorage.setItem('investor_token', queryToken);
    window.history.replaceState({}, document.title, window.location.pathname);
    return queryToken;
  }

  // 2. Check Cookie (.sourceseas.com)
  const cookieMatch = document.cookie.match(/(?:^|; )investor_token=([^;]*)/);
  if (cookieMatch) {
    const cookieToken = decodeURIComponent(cookieMatch[1]);
    sessionStorage.setItem('investor_token', cookieToken);
    return cookieToken;
  }

  // 3. Check SessionStorage
  return sessionStorage.getItem('investor_token');
};

const requestHandler = (request: any) => {
  const token = getAuthToken();

  if (token) {
    const cleanToken = token.replace(/^"|"$/g, '');
    request.headers.Authorization = `Bearer ${cleanToken}`;
  }
  return request;
};

customAxios.interceptors.request.use(requestHandler);

export default customAxios;
